import React from "react";
import { Typography } from "@tiny/components";

interface SubscriberStatusProps {
  status?: string;
}

function SubscriberStatus(props: SubscriberStatusProps) {
  const { status } = props;

  if (!status) {
    return null;
  }

  if (status === "Unsubscribed") {
    return (
      <Typography variant="label2" color="red" tone="dark">
        {status}
      </Typography>
    );
  }

  if (status === "Subscribed") {
    return (
      <Typography variant="label2" color="primary" tone="main">
        {status}
      </Typography>
    );
  }

  return (
    <Typography variant="label2" color="grey" tone={900}>
      {status}
    </Typography>
  );
}

export default SubscriberStatus;
